"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ComplexDataError extends Error {
}
exports.default = ComplexDataError;
//# sourceMappingURL=../../src/complexDataError.js.map